import axios from './configObra/config-obra'

const defaultRoute = '/users'

export default {
  listAll: (empresa, filial) => {
    if (empresa && filial) {
      return axios.get(`${defaultRoute}?empresa=${empresa}&filial=${filial}`)
    } else if (empresa) {
      return axios.get(`${defaultRoute}?empresa=${empresa}`)
    } else {
      return axios.get(`${defaultRoute}`)
    }
  },
  list: (filter, filial) =>
    axios.get(`${defaultRoute}/filter?${filter}=${filial}`),
  create: (usuario) => axios.post(defaultRoute, usuario),
  update: (id, usuario) => axios.patch(`${defaultRoute}/${id}`, usuario),
  remove: (id) => axios.delete(`${defaultRoute}/${id}`),
  changePassword: (id, changePassword) =>
    axios.patch(`${defaultRoute}/change-password/${id}`, changePassword),
}
